module.exports = __webpack_public_path__ + "static/img/1_1_6_2.4753cf18.jpg";